import { useChargingStationDetails } from '../useChargingStationDetails';
import { RefetchOnError, NoGeneralDetails } from '@energy-stacks/shared';
import { ChargingStationGeneralDetailsV21 } from './ChargingStationGeneralDetailsV21';

export const ChargingStationDetailsGeneralTabV21 = () => {
  const { chargingStationDetails, isSuccess, isError, refetch } =
    useChargingStationDetails();

  return (
    <>
      {isError ? <RefetchOnError onRefetch={refetch} /> : null}
      {!chargingStationDetails && isSuccess ? (
        <NoGeneralDetails onRefetch={refetch} />
      ) : (
        <ChargingStationGeneralDetailsV21 />
      )}
    </>
  );
};

